"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSignVaccineDeclinationAgreementDto = instanceOfSignVaccineDeclinationAgreementDto;
exports.SignVaccineDeclinationAgreementDtoFromJSON = SignVaccineDeclinationAgreementDtoFromJSON;
exports.SignVaccineDeclinationAgreementDtoFromJSONTyped = SignVaccineDeclinationAgreementDtoFromJSONTyped;
exports.SignVaccineDeclinationAgreementDtoToJSON = SignVaccineDeclinationAgreementDtoToJSON;
exports.SignVaccineDeclinationAgreementDtoToJSONTyped = SignVaccineDeclinationAgreementDtoToJSONTyped;
const VaccinationDeclinationReason_1 = require("./VaccinationDeclinationReason");
/**
 * Check if a given object implements the SignVaccineDeclinationAgreementDto interface.
 */
function instanceOfSignVaccineDeclinationAgreementDto(value) {
    if (!('signature' in value) || value['signature'] === undefined)
        return false;
    if (!('reasons' in value) || value['reasons'] === undefined)
        return false;
    return true;
}
function SignVaccineDeclinationAgreementDtoFromJSON(json) {
    return SignVaccineDeclinationAgreementDtoFromJSONTyped(json, false);
}
function SignVaccineDeclinationAgreementDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'signature': json['signature'],
        'reasons': (json['reasons'].map(VaccinationDeclinationReason_1.VaccinationDeclinationReasonFromJSON)),
    };
}
function SignVaccineDeclinationAgreementDtoToJSON(json) {
    return SignVaccineDeclinationAgreementDtoToJSONTyped(json, false);
}
function SignVaccineDeclinationAgreementDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'signature': value['signature'],
        'reasons': (value['reasons'].map(VaccinationDeclinationReason_1.VaccinationDeclinationReasonToJSON)),
    };
}
//# sourceMappingURL=SignVaccineDeclinationAgreementDto.js.map